<template>
  <div id="sea-page">
    <sea-header v-if="header" :separator="headerSeparator">{{
      header
    }}</sea-header>
    <v-container fluid id="sea-page-content">
      <slot></slot>
    </v-container>
  </div>
</template>

<script>
import { APPLICATION_NAME } from "../constants";
export default {
  name: "sea-page",
  props: {
    title: String,
    header: String,
    headerSeparator: { type: Boolean, default: false },
  },
  mounted() {
    document.title = `${APPLICATION_NAME} - ${this.title}`;
  },
};
</script>

<style>
#sea-page {
  height: 98%;
}
#sea-page-content {
  height: 97%;
}
</style>